var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('img',{attrs:{"alt":"sanitas-logo","src":require("../../assets/sanitasLogo.svg")}}),_c('p',[_c('small',[_vm._v(_vm._s(_vm.texts.header_label))])])])}
var staticRenderFns = []

export { render, staticRenderFns }